"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MixpanelDevProjectId = exports.MixpanelProductionProjectId = void 0;
const MixpanelProductionProjectId = '9f6c36f25486a2ec13e9441ec8275c74';
exports.MixpanelProductionProjectId = MixpanelProductionProjectId;
const MixpanelDevProjectId = 'b87c4236ff83da3aebbfbf9952c754df';
exports.MixpanelDevProjectId = MixpanelDevProjectId;